import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { fetchContentLibrary } from '../../util/api';

export const FETCH_CONTENT_LIBRARY_REQUEST = 'app/ContentLibraryPage/FETCH_REQUEST';
export const FETCH_CONTENT_LIBRARY_SUCCESS = 'app/ContentLibraryPage/FETCH_SUCCESS';
export const FETCH_CONTENT_LIBRARY_ERROR = 'app/ContentLibraryPage/FETCH_ERROR';

const initialState = {
  fetchInProgress: false,
  hasFetched: false,
  fetchError: null,
  groups: [],
};

export default function contentLibraryPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CONTENT_LIBRARY_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_CONTENT_LIBRARY_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        hasFetched: true,
        groups: payload?.groups || [],
      };
    case FETCH_CONTENT_LIBRARY_ERROR:
      return { ...state, fetchInProgress: false, hasFetched: true, fetchError: payload };
    default:
      return state;
  }
}

export const fetchContentLibraryRequest = () => ({ type: FETCH_CONTENT_LIBRARY_REQUEST });
export const fetchContentLibrarySuccess = data => ({
  type: FETCH_CONTENT_LIBRARY_SUCCESS,
  payload: data,
});
export const fetchContentLibraryError = e => ({
  type: FETCH_CONTENT_LIBRARY_ERROR,
  payload: e,
  error: true,
});

export const getContentLibraryGroups = state => state.ContentLibraryPage?.groups || [];
export const getContentLibraryFetchInProgress = state =>
  state.ContentLibraryPage?.fetchInProgress || false;
export const getContentLibraryHasFetched = state => !!state.ContentLibraryPage?.hasFetched;
export const getContentLibraryFetchError = state => state.ContentLibraryPage?.fetchError || null;

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(fetchContentLibraryRequest());
  return fetchContentLibrary()
    .then(res => {
      const groups = res?.data?.groups || [];
      dispatch(fetchContentLibrarySuccess({ groups }));
      return res;
    })
    .catch(e => {
      log.error(e, 'content-library-fetch-failed');
      dispatch(fetchContentLibraryError(storableError(e)));
      throw e;
    });
};
